var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddLedgerButtonSign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 15V2.5C20 1.83696 19.7366 1.20107 19.2678 0.732233C18.7989 0.263392 18.163 0 17.5 0C16.837 0 16.2011 0.263392 15.7322 0.732233C15.2634 1.20107 15 1.83696 15 2.5V15H2.5C1.83696 15 1.20107 15.2634 0.732233 15.7322C0.263392 16.2011 0 16.837 0 17.5C0 18.163 0.263392 18.7989 0.732233 19.2678C1.20107 19.7366 1.83696 20 2.5 20H15V32.5C15 33.163 15.2634 33.7989 15.7322 34.2678C16.2011 34.7366 16.837 35 17.5 35C18.163 35 18.7989 34.7366 19.2678 34.2678C19.7366 33.7989 20 33.163 20 32.5V20H32.5C33.163 20 33.7989 19.7366 34.2678 19.2678C34.7366 18.7989 35 18.163 35 17.5C35 16.837 34.7366 16.2011 34.2678 15.7322C33.7989 15.2634 33.163 15 32.5 15H20Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddLedgerButtonSign);
export default __webpack_public_path__ + "static/media/AddLedgerButtonSign.c069a91a574f9f30cf5eb28d4522f3a9.svg";
export { ForwardRef as ReactComponent };